import { useState, useEffect } from 'react';
import { SectionHeading, DayListItem } from '../components';
import { Skeleton } from '../components/ui/skeleton';
import { fetchUpcomingHolyDays } from '../utilities/api'; // Import API function

const Holidays = ({ data }) => {
    
  const { count, sectionDetails } = data;
  const [isLoading, setIsLoading] = useState(true);
  const [getHolyDays, setHolyDays] = useState({});

  useEffect(() => {
    
    const loadUpcomingHolyDays = async () => {
      try {
        setIsLoading(true);
        const response = await fetchUpcomingHolyDays(count);
        setHolyDays(response);
      } catch (error) {
        console.error('Error loading catchesis data:', error);
      } finally {
        setIsLoading(false);
      }
    };

    loadUpcomingHolyDays();
  }, [count]);

  return (
    <>
      {/* Render the section heading */}
      <SectionHeading 
        title={sectionDetails.title} 
        icon={sectionDetails.icon} 
        link={sectionDetails.link} 
      />
      
      {/* Render the list of upcoming holidays */}
      <div className="flex flex-col justify-between mt-4 bg-custom-light bg-white-50 rounded-xl">
        {isLoading ? (
          Array.from({ length: 3 }).map((_, index) => (
            <div key={index} className="p-4 border-b border-gray-200 last:border-b-0">
              <Skeleton className="w-3/4 h-6 rounded-md" />
              <Skeleton className="w-1/2 h-4 mt-2 rounded-md" />
            </div>
          ))
        ) : (
          Object.keys(getHolyDays).length > 0 ? (
            Object.values(getHolyDays).map((holiday, index) => (
              <DayListItem key={index} holiday={holiday} />
            ))
          ) : (
            <p className="p-4 text-gray-500">No upcoming holidays available.</p>
          )
        )}
      </div>
    </>
  );
};

export default Holidays;